export const uploadToCloudinary = async (
  file: File,
  onProgress?: (progress: number) => void,
  folderName: string = 'readora/seller-listings'
): Promise<string> => {
  const cloudName = 'dhchvqvfg';
  const uploadPreset = 'readora_unsigned';
  const folder = folderName;
  
  const url = `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`;
  
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', uploadPreset);
  formData.append('folder', folder);

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);

    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) {
        const percentComplete = Math.round((e.loaded / e.total) * 100);
        onProgress(percentComplete);
      }
    };

    xhr.onload = () => {
      if (xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        resolve(response.secure_url);
      } else {
        try {
          const err = JSON.parse(xhr.responseText);
          reject(new Error(err.error?.message || 'Upload failed'));
        } catch {
          reject(new Error('Upload failed'));
        }
      }
    };

    xhr.onerror = () => reject(new Error('Network error during upload'));
    
    xhr.send(formData);
  });
};

// ── Video Upload (Flip-Test) ──────────────────────────────────────────────────
export const uploadVideoToCloudinary = async (
  file: File,
  onProgress?: (progress: number) => void,
  folderName: string = 'readora/flip-test'
): Promise<string> => {
  const cloudName = 'dhchvqvfg';
  const uploadPreset = 'readora_unsigned';
  const folder = folderName;
  
  const url = `https://api.cloudinary.com/v1_1/${cloudName}/video/upload`;
  
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', uploadPreset);
  formData.append('folder', folder);

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);

    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) {
        const percentComplete = Math.round((e.loaded / e.total) * 100);
        onProgress(percentComplete);
      }
    };

    xhr.onload = () => {
      if (xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        resolve(response.secure_url);
      } else {
        try {
          const err = JSON.parse(xhr.responseText);
          reject(new Error(err.error?.message || 'Video upload failed'));
        } catch {
          reject(new Error('Video upload failed'));
        }
      }
    };

    xhr.onerror = () => reject(new Error('Network error during video upload'));
    
    xhr.send(formData);
  });
};
